import { useIntl } from "react-intl";
import { Icon, Segment } from "semantic-ui-react";

const DoubleApprovalCreativeStatusChangeMessage = () => {
  const intl = useIntl();

  return (
    <Segment secondary>
      <Icon name="attention" />
      {intl.formatMessage({
        defaultMessage: "This is an admin approved creative. Only a status change is permitted.",
        id: "NOTE_DOUBLE_CREATIVE_APPROVAL_STATUS_CHANGE",
      })}
    </Segment>
  );
};

export default DoubleApprovalCreativeStatusChangeMessage;
